import React from "react";
import { useTranslation } from "react-i18next";
import { cn } from "@/lib/utils";

/** OneGate monogram: a gate/portal glyph on the primary color. Text can be hidden (collapsed sidebar). */
export const BrandLogo = ({ compact = false, className = "", size = "md" }) => {
  const { t } = useTranslation();
  const box = size === "lg" ? "h-11 w-11 rounded-xl" : "h-9 w-9 rounded-lg";
  return (
    <div className={cn("flex items-center gap-3", className)} data-testid="brand-logo">
      <div className={cn(box, "flex shrink-0 items-center justify-center bg-primary text-primary-foreground shadow-sm")} aria-hidden="true">
        <svg viewBox="0 0 24 24" className={size === "lg" ? "h-6 w-6" : "h-5 w-5"} fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M5 20V10a7 7 0 0 1 14 0v10" />
          <path d="M9 20v-6a3 3 0 0 1 6 0v6" />
          <path d="M3 20h18" />
        </svg>
      </div>
      {!compact && (
        <div className="leading-tight">
          <div className={cn("font-heading font-semibold tracking-tight text-foreground", size === "lg" ? "text-lg" : "text-[15px]")}>OneGate</div>
          <div className="text-[11px] font-medium uppercase tracking-[0.14em] text-muted-foreground">{t("app.name").replace(/^OneGate\s*/i, "")}</div>
        </div>
      )}
    </div>
  );
};
